module.exports = __webpack_public_path__ + "assets/language-squares/de@2x-27f9a20fc4b03d196f5bd26423b8720d.jpg";